<template>
  <span class="third-party-account-add">
    <el-button
      class="client-eval-add-btn"
      icon="el-icon-plus"
      type="primary"
      :disabled="disabled"
      @click="openAddDialog"
      >添加</el-button
    >

    <FormDialog
      :visible="showAddDialog"
      :title="dialogTitle"
      :width="820"
      @close="closeAddDialog"
    >
      <el-form
        ref="thirdPartyAddForm"
        :model="addForm"
        :rules="addFormRules"
        size="small"
        label-width="130px"
        label-position="right"
        class="third-party-add-pop__form"
        @submit.native.prevent
      >
        <el-form-item label="第三方系统名称" prop="brokerName">
          <el-input
            v-model="addForm.brokerName"
            class="third-party-add-pop__control"
            placeholder="请输入第三方系统名称"
          />
        </el-form-item>
        <el-form-item label="brokerID" prop="otherBrokerId">
          <el-input
            v-model="addForm.otherBrokerId"
            class="third-party-add-pop__control"
            placeholder="请输入brokerID"
            @input="onOtherBrokerIdInput"
          />
        </el-form-item>
        <el-form-item
          label="经纪商地址"
          prop="brokerAddressGate"
          class="third-party-add-pop__address-form-item"
        >
          <input
            v-model="addForm.brokerAddressGate"
            type="hidden"
            tabindex="-1"
            aria-hidden="true"
          />
          <div class="third-party-add-pop__address-box">
            <div
              v-for="row in brokerAddressRows"
              :key="row._id"
              class="third-party-add-pop__address-block"
            >
              <div class="third-party-add-pop__address-row">
                <span class="third-party-add-pop__addr-label">协议:</span>
                <el-select
                  v-model="row.protocol"
                  class="third-party-add-pop__proto"
                  placeholder="协议"
                  disabled
                >
                  <el-option label="tcp://" value="tcp://" />
                  <el-option label="ssl://" value="ssl://" />
                </el-select>
                <span class="third-party-add-pop__addr-label"
                  >{{ addressRowLabel() }}:</span
                >
                <div class="third-party-add-pop__addr-ip">
                  <IpAddrInput
                    :IP="row.address"
                    @changeIP="(ip) => onAddressRowIpChange(row, ip)"
                  />
                </div>
                <span class="third-party-add-pop__addr-label">端口:</span>
                <div class="third-party-add-pop__addr-port">
                  <el-input-number
                    v-model="row.port"
                    size="small"
                    :min="1"
                    :max="65535"
                    :precision="0"
                    :controls="false"
                    placeholder=""
                    class="third-party-add-pop__port-num"
                  />
                </div>
                <i
                  v-if="isRemovableBrokerAddress(row)"
                  class="el-icon-delete third-party-add-pop__addr-del"
                  title="删除该交易地址"
                  @click="removeBrokerAddress(row)"
                />
              </div>
            </div>
            <el-button
              class="client-eval-add-btn"
              type="primary"
              icon="el-icon-plus"
              :disabled="!canAddBrokerAddress"
              @click="addBrokerAddress"
              >增加地址</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="APPID" prop="appId">
          <el-input
            v-model="addForm.appId"
            class="third-party-add-pop__control"
            placeholder="请输入APPID"
          />
        </el-form-item>
        <el-form-item label="系统信息" prop="systemInfo">
          <el-input
            v-model="addForm.systemInfo"
            class="third-party-add-pop__control"
            placeholder="请输入系统信息"
          />
        </el-form-item>
        <el-form-item label="授权码" prop="authCode">
          <el-input
            v-model="addForm.authCode"
            class="third-party-add-pop__control"
            placeholder="请输入授权码"
          />
        </el-form-item>
        <el-form-item label="登录账户" prop="userCode">
          <el-input
            v-model="addForm.userCode"
            class="third-party-add-pop__control"
            placeholder="请输入登录账户"
          />
        </el-form-item>
        <el-form-item label="登录姓名" prop="userName">
          <el-input
            v-model="addForm.userName"
            class="third-party-add-pop__control"
            placeholder="请输入登录姓名"
          />
        </el-form-item>
        <el-form-item
          v-if="dialogMode === 'add'"
          label="登录密码"
          prop="userPwd"
        >
          <el-input
            v-model="addForm.userPwd"
            class="third-party-add-pop__control"
            placeholder="请输入登录密码"
            show-password
          />
        </el-form-item>
      </el-form>

      <template slot="footer">
        <el-button
          class="indiv-btn"
          type="primary"
          size="small"
          :loading="submitting"
          @click="onAddSubmitStub"
        >
          提交
        </el-button>
      </template>
    </FormDialog>

    <AccountTrialLimitDialog
      :visible.sync="showTrialLimitDialog"
      @purchase="$emit('purchase')"
    />
  </span>
</template>

<script>
import IpAddrInput from "./input.vue";
import { normalizeOtherBroker } from "./otherBroker";
import AccountTrialLimitDialog, {
  isTrialAccountLimitError,
} from "../AccountTrialLimitDialog.vue";

/**
 * 第三方账户添加/编辑弹窗
 * - 保存：direct_saveNew / direct_saveEdit，userType 固定为 5
 * - otherBrokerId、brokerName、tradeAddr（| 拼接）；行情地址不再采集
 */

function emptyAddForm() {
  return {
    otherBrokerId: "",
    brokerName: "",
    brokerAddressGate: "",
    userCode: "",
    userName: "",
    appId: "",
    systemInfo: "",
    authCode: "",
    userPwd: "",
  };
}

/** 解析 otherBroker（JSON 字符串或对象） */
function parseOtherBroker(raw) {
  return (
    normalizeOtherBroker(raw) ||
    (raw && typeof raw === "object" && !Array.isArray(raw) ? raw : null)
  );
}

/** 经纪商 ID：仅保留英文字母与数字 */
function sanitizeOtherBrokerId(val) {
  return String(val == null ? "" : val).replace(/[^a-zA-Z0-9]/g, "");
}

/** 与列表一致：经纪商 ID 只认 otherBroker.brokerId */
function brokerIdFromOtherBroker(other) {
  if (!other || other.brokerId == null || other.brokerId === "") return "";
  return sanitizeOtherBrokerId(other.brokerId);
}

/** 经纪商交易地址最多条数 */
const MAX_BROKER_ADDRESSES = 10;

/** 编辑：列表行 + edit_ajax entity 合并为弹窗用的行数据 */
function mergeListRowWithEditAjaxEntity(listRow, entity) {
  if (!entity || typeof entity !== "object") return listRow;

  const out = { ...listRow, ...entity };
  out.userType = listRow.userType;
  out.userTypeName = listRow.userTypeName;

  const fromList = parseOtherBroker(listRow.otherBroker);
  const fromEdit = parseOtherBroker(entity.otherBroker);
  const merged = { ...(fromList || {}), ...(fromEdit || {}) };
  const brokerId =
    fromEdit && fromEdit.brokerId != null && fromEdit.brokerId !== ""
      ? fromEdit.brokerId
      : fromList && fromList.brokerId != null && fromList.brokerId !== ""
      ? fromList.brokerId
      : null;
  if (brokerId != null && brokerId !== "") merged.brokerId = brokerId;
  if (Object.keys(merged).length) {
    out.otherBroker = merged;
    const name =
      merged.brokerName != null ? String(merged.brokerName).trim() : "";
    if (name) {
      out.brokerName = name;
      out.serverManageName = name;
    }
  }

  if (entity.userName != null && String(entity.userName).trim() !== "") {
    out.userName = entity.userName;
  }
  if (entity.userCode != null && String(entity.userCode).trim() !== "") {
    out.userCode = entity.userCode;
  }
  if (entity.appId != null && String(entity.appId).trim() !== "") {
    out.appId = entity.appId;
  }
  if (entity.systemInfo != null && String(entity.systemInfo).trim() !== "") {
    out.systemInfo = entity.systemInfo;
  }
  if (entity.authCode != null && String(entity.authCode).trim() !== "") {
    out.authCode = entity.authCode;
  }
  return out;
}

// —— 地址行 / 经纪商下拉 ——

function genAddressRowId() {
  return `addr-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

function isValidIpv4(ip) {
  const s = String(ip || "").trim();
  if (!s) return false;
  return /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(
    s
  );
}

function defaultBrokerAddressRows() {
  return [
    {
      _id: genAddressRowId(),
      protocol: "tcp://",
      address: "",
      port: undefined,
      kind: "trade",
    },
  ];
}

function splitBrokerAddrSegments(val) {
  if (val == null || val === "") return [];
  if (Array.isArray(val)) {
    return val.map((x) => String(x).trim()).filter((s) => s.length > 0);
  }
  return String(val)
    .split("|")
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
}

// —— 表单校验片段 ——

function requiredTrimRule(message) {
  return {
    validator(rule, value, callback) {
      if (value != null && String(value).length > 0 && !String(value).trim()) {
        callback(new Error(message));
        return;
      }
      callback();
    },
    trigger: "blur",
  };
}

function otherBrokerIdFormatRule() {
  return {
    validator(rule, value, callback) {
      const s = String(value || "").trim();
      if (!s) {
        callback();
        return;
      }
      if (!/^[a-zA-Z0-9]+$/.test(s)) {
        callback(new Error("brokerID只能为英文字母或数字"));
        return;
      }
      callback();
    },
    trigger: "blur",
  };
}

export default {
  name: "ThirdPartyAccountAdd",
  components: { IpAddrInput, AccountTrialLimitDialog },
  props: {
    /** status 为 2/3 时由列表传入，禁止添加 */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    addFormRules() {
      return {
        otherBrokerId: [
          { required: true, message: "请输入brokerID", trigger: "blur" },
          requiredTrimRule("请输入brokerID"),
          otherBrokerIdFormatRule(),
        ],
        brokerName: [
          { required: true, message: "请输入第三方系统名称", trigger: "blur" },
          requiredTrimRule("请输入第三方系统名称"),
        ],
        brokerAddressGate: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const { error } = this.inspectBrokerAddressRowsForSubmit();
              if (error) {
                callback(new Error(error));
                return;
              }
              callback();
            },
            trigger: [],
          },
        ],
        userCode: [
          {
            required: true,
            message: "请输入登录账户",
            trigger: "change",
          },
        ],
        appId: [
          { required: true, message: "请输入APPID", trigger: "blur" },
          requiredTrimRule("请输入APPID"),
        ],
        authCode: [
          { required: true, message: "请输入授权码", trigger: "blur" },
          requiredTrimRule("请输入授权码"),
        ],
        userPwd: [
          {
            required: this.dialogMode === "add",
            message: "请输入登录密码",
            trigger: "change",
          },
        ],
      };
    },
    dialogTitle() {
      return this.dialogMode === "edit" ? "编辑第三方账户" : "添加第三方账户";
    },
    canAddBrokerAddress() {
      return this.brokerAddressRows.length < MAX_BROKER_ADDRESSES;
    },
  },
  data() {
    return {
      showAddDialog: false,
      dialogMode: "add",
      editingRowId: null,
      submitting: false,
      showTrialLimitDialog: false,
      addForm: emptyAddForm(),
      brokerAddressRows: defaultBrokerAddressRows(),
    };
  },
  methods: {
    // —— 通用 ——

    apiToken() {
      try {
        const t = JSON.parse(localStorage.getItem("token") || "{}");
        return t.apiToken || this.$store.state.usermsg.apiToken;
      } catch (e) {
        return this.$store.state.usermsg.apiToken;
      }
    },
    clearAddFormValidate() {
      this.$nextTick(() => {
        const form = this.$refs.thirdPartyAddForm;
        if (form) form.clearValidate();
      });
    },
    parseBrokerAddLine(line, opts = {}) {
      const kind = (opts && opts.kind) || "trade";
      const s = String(line || "").trim();
      const base = {
        kind,
      };
      const m = s.match(/^(tcp:\/\/|ssl:\/\/)([^:]+):(\d+)$/i);
      if (m) {
        return {
          _id: genAddressRowId(),
          ...base,
          protocol: m[1].toLowerCase() === "ssl://" ? "ssl://" : "tcp://",
          address: m[2],
          port: Number(m[3]),
        };
      }
      const m2 = s.match(/^([\d.]+):(\d+)$/);
      if (m2) {
        return {
          _id: genAddressRowId(),
          ...base,
          protocol: "tcp://",
          address: m2[1],
          port: Number(m2[2]),
        };
      }
      return {
        _id: genAddressRowId(),
        ...base,
        protocol: s.indexOf("ssl://") === 0 ? "ssl://" : "tcp://",
        address: s.replace(/^(tcp:\/\/|ssl:\/\/)/i, ""),
        port: null,
      };
    },
    // —— 第三方地址：解析 / 校验 / 提交拼接 ——

    /** 有填写的行校验 IP+端口，拼成 tradeAddr（| 分隔）；行情地址不再采集 */
    inspectBrokerAddressRowsForSubmit() {
      if (this.brokerAddressRows.length > MAX_BROKER_ADDRESSES) {
        return {
          tradeAddr: "",
          mdAddr: "",
          error: `经纪商地址最多 ${MAX_BROKER_ADDRESSES} 条`,
        };
      }
      const tradeParts = [];
      for (let i = 0; i < this.brokerAddressRows.length; i++) {
        const r = this.brokerAddressRows[i];
        if (r.kind === "quote") {
          continue;
        }
        const hasIp = this.addressFilled(r.address);
        const hasPort = this.portFilled(r.port);
        if (!hasIp && !hasPort) {
          continue;
        }
        if (!hasIp || !hasPort) {
          return {
            tradeAddr: "",
            mdAddr: "",
            error: `交易地址（第 ${i + 1} 行）需填写完整 IP 与端口`,
          };
        }
        const ip = String(r.address || "").trim();
        if (!isValidIpv4(ip)) {
          return {
            tradeAddr: "",
            mdAddr: "",
            error: `交易地址（第 ${i + 1} 行）IP 格式不正确`,
          };
        }
        const proto = r.protocol || "tcp://";
        tradeParts.push(`${proto}${ip}:${Number(r.port)}`);
      }
      if (!tradeParts.length) {
        return {
          tradeAddr: "",
          mdAddr: "",
          error: "请填写交易地址",
        };
      }
      return {
        tradeAddr: tradeParts.join("|"),
        mdAddr: "",
        error: null,
      };
    },
    /** 编辑回显：otherBroker.tradeAddr → 交易地址行 */
    buildBrokerRowsFromOtherTradeMd(other) {
      if (!other || typeof other !== "object") {
        return null;
      }
      const tradeParts = splitBrokerAddrSegments(other.tradeAddr);
      if (!tradeParts.length) {
        return null;
      }
      return tradeParts.map((tLine) =>
        this.parseBrokerAddLine(tLine, { kind: "trade" })
      );
    },
    // —— 保存 ——

    buildDirectSaveFormBodyString(isEdit) {
      const parts = [];
      const push = (k, v) => {
        if (v === undefined || v === null) {
          return;
        }
        const s = String(v);
        if (s === "") {
          return;
        }
        parts.push(encodeURIComponent(k) + "=" + encodeURIComponent(s));
      };
      push("apiToken", this.apiToken());
      push("userType", 5);
      const userCode = String(this.addForm.userCode || "").trim();
      const userName =
        String(this.addForm.userName || "").trim() || userCode;
      push("userCode", userCode);
      push("userName", userName);
      push("appId", String(this.addForm.appId || "").trim());
      push("systemInfo", String(this.addForm.systemInfo || "").trim());
      push("authCode", String(this.addForm.authCode || "").trim());
      if (!isEdit) {
        push("userPwd", String(this.addForm.userPwd || "").trim());
      }
      if (isEdit && this.editingRowId != null && this.editingRowId !== "") {
        push("id", this.editingRowId);
      }
      push(
        "otherBrokerId",
        sanitizeOtherBrokerId(this.addForm.otherBrokerId)
      );
      push("brokerName", String(this.addForm.brokerName || "").trim());
      const { tradeAddr, mdAddr } = this.inspectBrokerAddressRowsForSubmit();
      push("tradeAddr", tradeAddr);
      push("mdAddr", mdAddr);
      return parts.join("&");
    },
    // —— 弹窗：打开 / 回显 ——

    /** 列表点编辑：拉详情 edit_ajax，填入表单 */
    openForEdit(listRow) {
      if (!listRow) {
        return;
      }
      this.dialogMode = "edit";
      this.$axios
        .post("/cloud/eval_jees/edit_ajax", {
          id: listRow.id,
          apiToken: this.apiToken(),
        })
        .then((res) => {
          this.tokenInvalid(res);
          let row = listRow;
          if (
            res &&
            res.data &&
            res.data.code == 200 &&
            res.data.data &&
            res.data.data.entity
          ) {
            row = mergeListRowWithEditAjaxEntity(
              listRow,
              res.data.data.entity
            );
          }
          this.hydrateEditDialogFromListRow(row);
        })
        .catch(() => {
          this.hydrateEditDialogFromListRow(listRow);
        });
    },
    /** 第三方：回显经纪商交易地址（优先 tradeAddr） */
    resolveThirdAddressRows(listRow, other) {
      const fromTradeMd = this.buildBrokerRowsFromOtherTradeMd(other);
      if (fromTradeMd && fromTradeMd.length) return fromTradeMd;

      const info =
        other && Array.isArray(other.brokerInfo) && other.brokerInfo.length
          ? other.brokerInfo
          : null;
      if (info) {
        const tradeRows = [];
        for (let i = 0; i < info.length; i += 2) {
          tradeRows.push(
            this.parseBrokerAddLine(info[i], { kind: "trade" })
          );
        }
        return tradeRows.length ? tradeRows : defaultBrokerAddressRows();
      }

      const arr = listRow.ctpBrokerAddresses;
      if (arr && arr.length) {
        const out = [];
        for (let i = 0; i < arr.length; i++) {
          const a = arr[i];
          if (a.kind === "quote") {
            continue;
          }
          out.push({
            _id: genAddressRowId(),
            protocol: a.protocol || "tcp://",
            address: a.address || "",
            port: a.port != null && a.port !== "" ? Number(a.port) : null,
            kind: "trade",
          });
        }
        return out.length ? out : defaultBrokerAddressRows();
      }
      return defaultBrokerAddressRows();
    },

    /** 列表行 / 合并后的详情 → 表单 */
    hydrateEditDialogFromListRow(listRow) {
      this.editingRowId = listRow.id;
      const other = parseOtherBroker(listRow.otherBroker);

      this.addForm = {
        ...emptyAddForm(),
        otherBrokerId: brokerIdFromOtherBroker(other),
        brokerName:
          other && other.brokerName != null
            ? String(other.brokerName).trim()
            : "",
        userCode: listRow.userCode || "",
        userName: listRow.userName || "",
        appId: listRow.appId != null ? String(listRow.appId) : "",
        systemInfo:
          listRow.systemInfo != null ? String(listRow.systemInfo) : "",
        authCode: listRow.authCode != null ? String(listRow.authCode) : "",
      };
      this.brokerAddressRows = this.resolveThirdAddressRows(listRow, other);
      this.showAddDialog = true;
      this.clearAddFormValidate();
    },

    openAddDialog() {
      if (this.disabled) return;
      this.dialogMode = "add";
      this.editingRowId = null;
      this.addForm = emptyAddForm();
      this.brokerAddressRows = defaultBrokerAddressRows();
      this.showAddDialog = true;
      this.clearAddFormValidate();
    },

    closeAddDialog() {
      this.showAddDialog = false;
      this.dialogMode = "add";
      this.editingRowId = null;
      this.submitting = false;
      this.addForm = emptyAddForm();
      this.brokerAddressRows = defaultBrokerAddressRows();
      this.clearAddFormValidate();
    },
    onOtherBrokerIdInput(val) {
      const next = sanitizeOtherBrokerId(val);
      if (next !== this.addForm.otherBrokerId) {
        this.addForm.otherBrokerId = next;
      }
    },
    /** 行展示文案 */
    addressRowLabel() {
      return "交易地址";
    },
    /** 多条时允许删 */
    isRemovableBrokerAddress() {
      return this.brokerAddressRows.length > 1;
    },
    /** 追加一条交易地址 */
    addBrokerAddress() {
      if (!this.canAddBrokerAddress) {
        return;
      }
      this.brokerAddressRows.push({
        _id: genAddressRowId(),
        protocol: "tcp://",
        address: "",
        port: undefined,
        kind: "trade",
      });
    },
    /** 删除一条交易地址；至少保留一条 */
    removeBrokerAddress(row) {
      if (!row || this.brokerAddressRows.length <= 1) {
        return;
      }
      this.brokerAddressRows = this.brokerAddressRows.filter(
        (r) => r._id !== row._id
      );
    },
    /** 地址：IP 组件有数字才算填过 */
    addressFilled(val) {
      return String(val || "").replace(/[^\d]/g, "").length > 0;
    },
    /** 端口：合法 TCP/UDP 端口 1–65535 */
    portFilled(val) {
      const n = Number(val);
      return (
        Number.isFinite(n) &&
        n === Math.floor(n) &&
        n >= 1 &&
        n <= 65535
      );
    },
    /** 地址行 IP 变更（经纪商地址在提交时统一校验） */
    onAddressRowIpChange(row, ip) {
      row.address = ip;
    },
    onAddSubmitStub() {
      const form = this.$refs.thirdPartyAddForm;
      if (!form || this.submitting) {
        return;
      }
      form.validate((valid) => {
        if (!valid) {
          return;
        }
        const isEdit =
          this.dialogMode === "edit" &&
          this.editingRowId != null &&
          this.editingRowId !== "";
        const url = isEdit
          ? "/cloud/eval_jees/direct_saveEdit"
          : "/cloud/eval_jees/direct_saveNew";
        const body = this.buildDirectSaveFormBodyString(isEdit);
        this.submitting = true;
        this.$axios({
          method: "post",
          url,
          data: body,
          transformRequest: [
            (data) => (typeof data === "string" ? data : data),
          ],
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        })
          .then((res) => {
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.$emit("saved");
              this.closeAddDialog();
            } else if (isTrialAccountLimitError(res, !isEdit)) {
              this.showTrialLimitDialog = true;
            } else {
              this.$alert(
                (res.data && (res.data.message || res.data.msg)) ||
                  "操作失败",
                {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true,
                }
              );
            }
          })
          .catch(() => {
            this.$alert("网络异常，请稍后重试", {
              confirmButtonText: "确定",
              type: "error",
              center: true,
            });
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.third-party-account-add {
  display: inline-block;
  vertical-align: middle;
}
.third-party-account-add >>> .third-party-add-pop__control {
  width: 100%;
  max-width: 510px;
  box-sizing: border-box;
}
.third-party-add-pop__address-form-item >>> .el-form-item__content {
  max-width: 100%;
}
.third-party-add-pop__address-box {
  box-sizing: border-box;
  width: 100%;
  max-width: 640px;
  padding: 0px;
  border-radius: 4px;
}
.third-party-add-pop__address-block {
  margin-bottom: 6px;
}
.third-party-add-pop__address-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 10px;
}
.third-party-add-pop__addr-label {
  font-size: 14px;
  color: #181e2d;
  white-space: nowrap;
}
.third-party-add-pop__proto {
  width: 85px;
}
.third-party-add-pop__proto >>> .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.third-party-add-pop__addr-ip {
  width: 160px;
  min-width: 160px;
}
.third-party-add-pop__addr-port {
  width: 90px;
  min-width: 90px;
}
.third-party-add-pop__port-num {
  width: 100%;
}
.third-party-add-pop__port-num >>> .el-input__inner {
  text-align: left;
}
.third-party-add-pop__addr-del {
  font-size: 18px;
  color: #5b85ff;
  cursor: pointer;
  margin-left: 2px;
  flex-shrink: 0;
  align-self: center;
  line-height: 1;
}
.third-party-add-pop__addr-del:hover {
  opacity: 0.85;
}
.third-party-add-pop__address-box >>> .client-eval-add-btn.el-button {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/user/eval_jees/third_party/ThirdPartyAccountAdd.vue